import { MERCHANT_CATEGORY_RESTAURANT } from '@/hooks/use-glammatic-api/use-glammatic-api.constants'
import { BRAND_IDENTITY_FISHERMAN } from '@/types/business.constants'

export function getCategory(business: Business) {
  const { category, brandIdentity } = business

  if (category) {
    return category
  }

  if (brandIdentity === BRAND_IDENTITY_FISHERMAN) {
    return 'Restaurant'
  }

  return 'Salon'
}

export function isRestaurantBusiness(business: Business | null | undefined): boolean {
  if (!business) {
    return false
  }

  if (business.category === MERCHANT_CATEGORY_RESTAURANT) {
    return true
  }

  if (business.brandIdentity === BRAND_IDENTITY_FISHERMAN) {
    return true
  }

  return /restaurant/i.test(business.category || '')
}
